import { useEffect, useState } from 'react';

interface DrawerProps {
  isOpen: boolean;
  children: any;
  onClose?: () => void;
}

const Drawer = ({ isOpen, children, onClose }: DrawerProps) => {
  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  const [shouldRenderChildren, setShouldRenderChildren] =
    useState<boolean>(false);

  useEffect(() => {
    setIsInitialized(isOpen);
  }, [isOpen]);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (isInitialized) {
      setShouldRenderChildren(true);
    } else {
      timeout = setTimeout(() => setShouldRenderChildren(false), 500);
    }

    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [isInitialized]);

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget && onClose) {
      onClose();
    }
  };

  const handleDrawerContentClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div
      className={`fixed left-0 top-0 z-[1000] ${
        isInitialized || shouldRenderChildren
          ? 'h-screen w-screen bg-black/10'
          : 'size-0'
      }`}
      role="presentation"
      onClick={handleBackdropClick}
    >
      <div
        className={`fixed right-0 top-0 flex h-screen w-screen justify-end  transition-transform duration-500 ease-in-out ${
          isInitialized ? 'translate-x-0' : 'translate-x-full'
        }`}
        role="presentation"
        onClick={handleBackdropClick}
      >
        <div
          className="h-screen w-fit overflow-y-auto bg-white shadow-2xl"
          role="presentation"
          onClick={handleDrawerContentClick}
        >
          {shouldRenderChildren && children}
        </div>
      </div>
    </div>
  );
};

export default Drawer;
